<template>
  <ButtonSquare
    :title="$t('general__view__mapview')"
    :imgSource="require('@/assets/icon-maps.svg')"
    size="large"
    @clicked="handleClick"
  />
</template>

<script>
import ButtonSquare from '@/components/general/buttons/ButtonSquare/ButtonSquare.vue'

export default {
  name: 'MapViewButton',
  components: {
    ButtonSquare
  },
  emits: ['mapviewButtonClick'],
  methods: {
    async handleClick() {
      // Needed to move logic to ViewButtons.vue because of joint view related v-if for viewbuttons
      this.$emit('mapviewButtonClick')
    }
  }
}
</script>
